import React, { Component } from 'react';
import { Row, Col, Carousel, Button, message } from 'antd';
import { RouteComponentProps } from 'react-router-dom';
import { LeftCircleOutlined, RightCircleOutlined, HistoryOutlined,
  PhoneOutlined, MailOutlined, CommentOutlined, TeamOutlined } from '@ant-design/icons';
import moment from 'moment';
import Footer_Logo from "../assets/images/footer_logo.svg";
import Footer_Er from "../assets/images/footer_erweima.png";
import { getTypelist, getBannerList } from '../apis/course';
import './index.less';

interface IProps  extends RouteComponentProps{};
interface IState {
  listData: any[],
  bannerData: any[]
};

class Home extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      listData: [], // 课程数据
      bannerData: [
        // {
        //   id: 1,
        //   file_url: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1596625831983&di=4d782641402ab8e8e728f37301053b6e&imgtype=0&src=http%3A%2F%2Fattachments.gfan.com%2Fforum%2F201608%2F04%2F2339412b3z30zbd2j6k652.jpg'
        // }, {
        //   id: 2,
        //   file_url: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1596625831983&di=293525b80f3d1d760ed8b558f73d2e70&imgtype=0&src=http%3A%2F%2Fattach.bbs.miui.com%2Fforum%2F201111%2F21%2F205700txzuacubbcy91u99.jpg'
        // }
      ], // banner数据
    };
  }
  componentDidMount() {
    this.getAllBanner();
    this.initialData();
  }
  // 获取banner
  getAllBanner = () => {
    let params = {
      limit: 0,
      page: 0
    };
    getBannerList(params).then((res: any) => {
      if (res && res.code === 0) {
        this.setState({
          bannerData: res.data.data || []
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }
  // 获取课程列表
  initialData = () => {
    let params = {
      page: 1,
      limit: 4
    }
    getTypelist(params).then((res: any) => {
      if (res && res.code === 0) {
        this.setState({
          listData: res.data || []
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }
  // 立即学习
  startStudy(id: string) {
    this.props.history.push(`/college/menu/main/course/detail/${id}`);
  }
  // 轮播图-查看详情
  goDetail(data: any) {
    if (data.type_id) { // 如果是分类id就跳转课程中心
      this.props.history.push(`/college/menu/main/course/${data.type_id}`)
    } else { // 是录入的课程就跳转课程详情
      this.props.history.push(`/college/menu/main/course/detail/${data.curriculum_id}`)
    }
  }
  // 点击更多-前往课程中心页面
  getMoreData(data: any) {
    this.props.history.push(`/college/menu/main/course/${data.id}`);
  }
  // 上一页
  handlePrev = () => {
    // this.refs.swipers.prev(); // 此方法会报错
    let _handle: any = this.refs.swipers;
    _handle.prev();
  }
  // 下一页
  handleNext = () => {
    // this.refs.swipers.prev(); // 此方法会报错
    let _handle: any = this.refs.swipers;
    console.log(_handle);
    _handle.next();
  };
  render() {
    const { listData, bannerData } = this.state;
    return (
      <div className="college_home">
        <div className="college_home_pagetop">
          {/* 菜单 */}
          <div className="menv" >
            {/* <MenuComp /> */}
          </div>
          <div className="swiper">
            <div className="swiper_left swiper_btn" onClick={this.handlePrev}>
              <LeftCircleOutlined />
            </div>
            <div className="swiper_right swiper_btn" onClick={this.handleNext}>
              <RightCircleOutlined />
            </div>
            <Carousel ref="swipers" effect='fade'>
              {
                bannerData && bannerData.map(item => {
                  return (
                    <div className="banner" 
                      key={item.file_url}
                    >
                      <div className='banner-info' style={{backgroundImage: `url(${item.file_url})`}}>
                        <div className="text">
                          <div className="text-empty"></div>
                          <div className="text-in">
                            <div className="title">{item.title}</div>
                            <div className="del">{item.profile}</div>
                            <Button type='primary' onClick={this.goDetail.bind(this, item)}>查看详情</Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              }
              {/* <div className="banner">
                <img src={BannerImg} alt="" style={{height: '100%'}} />
              </div>
              <div className="banner">
                <img src={BannerImg} alt=""/>
              </div>
              <div className="banner">
                <img src={BannerImg} alt=""/>
              </div> */}
            </Carousel>
          </div>
        </div>
        <Row className="contexts">
          <ul className="out_ul">
            {
              listData && listData.map((item1, index1) => {
                return (
                  <li className='out_ul_li' key={index1}>
                    <div className="top">
                      <p>{item1.type_name}</p>
                      <span onClick={this.getMoreData.bind(this, item1)} style={{cursor: 'pointer'}}>更多...</span>
                    </div>
                    <Row align='middle' gutter={32} className="in_ul">
                      {
                        item1.curriculums.map((item2: any, index2: any) => {
                          return (
                            <Col span={6} key={index2}>
                              <div className="in_ul_li">
                                <img src={item2.file_url} alt=""/>
                                <div className="text">
                                  <div className="title">{item2.curriculum_name}</div>
                                  <div className="line"></div>
                                  <div className="cour">
                                    <div className="left"> <TeamOutlined /> {item2.total_see}</div>
                                    <div className="right"> <HistoryOutlined /> {moment(item2.create_time * 1000).format("YYYY-MM-DD")}</div>
                                  </div>
                                  <Button type="primary" style={{width: '100%'}} onClick={this.startStudy.bind(this, item2.id)}>立即学习</Button>
                                </div>
                              </div>
                            </Col>
                          )
                        })
                      }
                    </Row>
                  </li>
                )
              })
            }
          </ul>
          {/* <ul className="out_ul">
            <li className='out_ul_li'>
              <div className="top">
                <p>教学教研</p>
                <span>更多...</span>
              </div>
              <Row align='middle' gutter={32} className="in_ul">
                <Col span={6}>
                  <div className="in_ul_li">
                    <img src={BannerImg} alt=""/>
                    <div className="text">
                      <div className="title">教学管理|骨干进阶_体系课_luojuan</div>
                      <div className="line"></div>
                      <div className="cour">共52节课</div>
                      <Button type="primary" style={{width: '100%'}}>立即学习</Button>
                    </div>
                  </div>
                </Col>
                <Col span={6}>
                  <div className="in_ul_li">
                    <img src={BannerImg} alt=""/>
                    <div className="text">
                      <div className="title">教学管理|骨干进阶_体系课_luojuan</div>
                      <div className="line"></div>
                      <div className="cour">共52节课</div>
                      <Button type="primary" style={{width: '100%'}}>立即学习</Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </li>
            <li className='out_ul_li'>
              <div className="top">
                <p>教学教研</p>
                <span>更多</span>
              </div>
              <Row align='middle' gutter={32} className="in_ul">
                <Col span={6}>
                  <div className="in_ul_li">
                    <img src={BannerImg} alt=""/>
                    <div className="text">
                      <div className="title">教学管理|骨干进阶_体系课_luojuan</div>
                      <div className="line"></div>
                      <div className="cour">共52节课</div>
                      <Button type="primary" style={{width: '100%'}}>立即学习</Button>
                    </div>
                  </div>
                </Col>
                <Col span={6}>
                  <div className="in_ul_li">
                    <img src={BannerImg} alt=""/>
                    <div className="text">
                      <div className="title">教学管理|骨干进阶_体系课_luojuan</div>
                      <div className="line"></div>
                      <div className="cour">共52节课</div>
                      <Button type="primary" style={{width: '100%'}}>立即学习</Button>
                    </div>
                  </div>
                </Col>
                <Col span={6}>
                  <div className="in_ul_li">
                    <img src={BannerImg} alt=""/>
                    <div className="text">
                      <div className="title">教学管理|骨干进阶_体系课_luojuan</div>
                      <div className="line"></div>
                      <div className="cour">
                        <div className="left"> <FileOutlined /> 共52节课</div>
                        <div className="right"> <HistoryOutlined /> 2020-09-21</div>
                      </div>
                      <Button type="primary" style={{width: '100%'}}>立即学习</Button>
                    </div>
                  </div>
                </Col>
                <Col span={6}>
                  <div className="in_ul_li">
                    <img src={BannerImg} alt=""/>
                    <div className="text">
                      <div className="title">教学管理|骨干进阶_体系课_luojuan</div>
                      <div className="line"></div>
                      <div className="cour">
                        <div className="left"> <FileOutlined /> 共52节课</div>
                        <div className="right"> <HistoryOutlined /> 2020-09-21</div>
                      </div>
                      <Button type="primary" style={{width: '100%'}}>立即学习</Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </li>
            <li className='out_ul_li'>
              <div className="top">
                <p>教学教研</p>
                <span>更多</span>
              </div>
              <Row align='middle' gutter={32} className="in_ul">
                <Col span={6}>
                  <div className="in_ul_li">
                    <img src={BannerImg} alt=""/>
                    <div className="text">
                      <div className="title">教学管理|骨干进阶_体系课_luojuan</div>
                      <div className="line"></div>
                      <div className="cour">共52节课</div>
                      <Button type="primary" style={{width: '100%'}}>立即学习</Button>
                    </div>
                  </div>
                </Col>
                <Col span={6}>
                  <div className="in_ul_li">
                    <img src={BannerImg} alt=""/>
                    <div className="text">
                      <div className="title">教学管理|骨干进阶_体系课_luojuan</div>
                      <div className="line"></div>
                      <div className="cour">共52节课</div>
                      <Button type="primary" style={{width: '100%'}}>立即学习</Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </li>
    </ul> */}
          <div className="footer">
            <div className="footer_in">
              <div className="footer_in_top">
                <div className="left">
                  <img src={Footer_Logo} alt=""/>
                  <div className="left_bot">
                    <img src={Footer_Er} alt=""/>
                    <ul>
                      <li><PhoneOutlined /> 400-8576-886</li>
                      <li><MailOutlined /> 邮箱</li>
                      <li><CommentOutlined /> 微博</li>
                    </ul>
                  </div>
                </div>
                <Row className='right' align="top" gutter={32}>
                  <Col span={6}>
                    <div className="right_item">
                      <p>关于我们</p>
                      <div className="line"></div>
                      <ul>
                        <li>公司概况</li>
                        <li>企业动态</li>
                        <li>加入我们</li>
                        <li>联系我们</li>
                      </ul>
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="right_item">
                      <p>产品服务</p>
                      <div className="line"></div>
                      <ul>
                        <li>账号管理</li>
                      </ul>
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="right_item">
                      <p>服务支持</p>
                      <div className="line"></div>
                      <ul>
                        <li>服务状态</li>
                      </ul>
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="right_item">
                      <p>合作与生态</p>
                      <div className="line"></div>
                      <ul>
                        <li>青云学院</li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="footer_in_bot">
                京ICP备13019086号  京公网安备11010502024565
              </div>
            </div>
          </div>
        </Row>
      </div>
    )
  }
}

export default Home;